import Model from './Model'

export default class Organization extends Model {
    resource()
    {
        return 'organizations'
    }
}
